<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 15:06:16
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 15:39:16
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 14:01:51
 * @LastEditors: lau
 * @LastEditTime: 2022-08-19 14:49:57
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 13:48:06
 * @LastEditors: lau
 * @LastEditTime: 2022-08-19 13:49:55
-->
<!-- 获取车辆欠费记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
            },
            responseCode: 	{
                "data": {
                    "currCount": 1,
                    "recordInList": [

                    ],
                    "total": 600
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查看授权商欠费图片详情",
                t_url: this.commonUrls.test+"getArrearsDetail",
                p_url: this.commonUrls.prod+"getArrearsDetail",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'topBillCode', info2: '否', info3: 'String', info4: '车牌号码' },
                     
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'enterCarCode', info2: '是', info3: 'String', info4: '进场车牌号码' },
                        { info1: 'leaveCarCode', info2: '否', info3: 'String', info4: '离场车牌号码' },
                        { info1: 'enterCarPic', info2: '是', info3: 'String', info4: '进场车辆图片' },
                        { info1: 'leaveCarPic', info2: '否', info3: 'String', info4: '离场车辆图片' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '停车记录编号' },
            
                        ]
                }
            ],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/record/getArrearsDetail.vue